// services/couponService.js
import axios from "axios";
import { API_END_POINTS } from "../../API_END_POINTS";

const couponValidate = `${process.env.REACT_APP_API_URL}${API_END_POINTS.couponValidate}`;

export const validateCoupon = async (couponCode) => {
  try {
    const response = await axios.post(
      `${couponValidate}`,
      { coupon_code: couponCode },
      {
        headers: {
          authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      }
    );
    return response.data; // Expected response: { valid: true, discount: 10 }
  } catch (error) {
    throw error.response?.data?.message || "Coupon validation failed";
  }
};
